import { Field, ID, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'

@ObjectType()
export class Trailer {
  @Field(() => ID, { nullable: true })
  @Prop({ type: String })
  _id?: string
}
